import { render, staticRenderFns } from "./DetailDemoRequest.vue?vue&type=template&id=a60a84c0&scoped=true&"
import script from "./DetailDemoRequest.vue?vue&type=script&lang=js&"
export * from "./DetailDemoRequest.vue?vue&type=script&lang=js&"
import style0 from "./DetailDemoRequest.vue?vue&type=style&index=0&id=a60a84c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60a84c0",
  null
  
)

export default component.exports